import { FC, ReactElement, useEffect, useRef, useState } from 'react'
import { Form, Row, Col, Button } from 'react-bootstrap'
import PeriodSelect from 'shared/components/PeriodSelect'
import { IModalReference } from 'shared/models/References'

type IProps = {
  startDate: Date
  endDate: Date
  maxStartDate: Date
  maxEndDate: Date
  endDateShouldBeAfterStartDate: boolean
  onDateChanged: (startDate: Date, endDate: Date) => void
}

const DateRangePicker: FC<Partial<IProps>> = (
  props: Partial<IProps>
): ReactElement => {
  const [startDate, setStartDate] = useState<Date>()
  const [endDate, setEndDate] = useState<Date>()
  const [isShowingDateRangeModal, setIsShowingDateRangeModal] = useState(true)
  const periodRef = useRef<IModalReference>()
  const [showDate, setShowDate] = useState(false)

  useEffect(() => {
    var shownStartDate = new Date(props.startDate)
    //TODO dit lijkt nodig om de datum correct te tonen ipv een dag eerder (kan dit vanuit API anders teruggegeven worden?)
    shownStartDate.setTime(shownStartDate.getTime() + 2 * 60 * 60 * 1000)
    setStartDate(shownStartDate)
    setEndDate(props.endDate)
    setShowDate(true)
  }, [])

  const onPeriodSelected = (selectedStartDate: Date, selectedEndDate: Date) => {
    setStartDate(selectedStartDate)
    setEndDate(selectedEndDate)
    props.onDateChanged(selectedStartDate, selectedEndDate)
  }

  const setNewStartDate = (date: Date) => {
    setStartDate(date)
    var tmpEndDate = endDate
    props.onDateChanged(date, startDate)
    if (props.endDateShouldBeAfterStartDate && endDate <= date) {
      tmpEndDate = date
      setEndDate(date)
    }
    props.onDateChanged(date, tmpEndDate)
  }

  const setNewEndDate = (date: Date) => {
    setEndDate(date)
    props.onDateChanged(startDate, date)
  }

  const hideDateModel = () => setIsShowingDateRangeModal(true)
  const showDateModel = () => setIsShowingDateRangeModal(false)

  /**
   * Assuming this component is being used in a table.
   */
  return (
    <tr className='border'>
      <td>
        <h5>Periode</h5>
      </td>
      <td colSpan={2}>
        {showDate && (
          <Form>
            <Form.Group as={Row} className='mb-3'>
              <Form.Label column sm={2} className='font-weight-bold text-right'>
                Ingangsdatum
              </Form.Label>
              <Col sm={8}>
                <Form.Control
                  type='date'
                  value={new Date(startDate).toISOString().split('T')[0]}
                  defaultValue={
                    //startDate?.toISOString().split('T')[0] ??
                    new Date().toISOString().split('T')[0]
                  }
                  onChange={e => {
                    let newDate: React.SetStateAction<Date>
                    try {
                      if (e.target.value) {
                        newDate = new Date(e.target.value)
                      } else {
                        newDate = new Date()
                      }
                    } catch {
                      newDate = new Date()
                    }
                    setNewStartDate(newDate)
                  }}
                />
              </Col>
              <Col sm={2}>
                <Button
                  variant='primary'
                  onClick={() => periodRef.current.show()}
                >
                  Kies periode
                </Button>
              </Col>
            </Form.Group>
            <Form.Group as={Row} className='mb-3'>
              <Form.Label column sm={2} className='font-weight-bold'>
                <span className='text-right'>Einddatum</span>
              </Form.Label>
              <Col sm={8}>
                <Form.Control
                  type='date'
                  min={
                    props.endDateShouldBeAfterStartDate
                      ? startDate?.toISOString().split('T')[0]
                      : ''
                  }
                  value={endDate?.toISOString().split('T')[0]}
                  defaultValue={
                    startDate?.toISOString().split('T')[0] ??
                    new Date().toISOString().split('T')[0]
                  }
                  onChange={e => {
                    let newDate: React.SetStateAction<Date>
                    try {
                      if (e.target.value) {
                        newDate = new Date(e.target.value)
                      } else {
                        newDate = new Date()
                      }
                    } catch {
                      try {
                        if (!!startDate) {
                          newDate = startDate
                        } else {
                          newDate = new Date()
                        }
                      } catch {
                        newDate = new Date()
                      }
                    }
                    setNewEndDate(newDate)
                  }}
                />
              </Col>
            </Form.Group>
          </Form>
        )}
      </td>

      <PeriodSelect
        ref={periodRef}
        initialStartDate={startDate}
        initialEndDate={endDate}
        maxEndDate={props.maxEndDate}
        onPeriodSelected={onPeriodSelected}
        onHide={hideDateModel}
        onShow={showDateModel}
        canClose={true}
      />
    </tr>
  )
}
export default DateRangePicker
